import React from 'react';

const Tails = {
  Classic: () => (
    <svg
      className="whatcrm-widget-message__tail"
      fill="none"
      height="32"
      viewBox="0 0 24 32"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M24.5415 32.5241H0.541473C14.7066 28.2804 24.4339 15.2939 24.5415 0.526367V32.5241Z"
        fillRule="evenodd"
      />
    </svg>
  ),
  Retro: () => (
    <svg
      className="whatcrm-widget-message__tail"
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M32.1472 0H15.2157C14.9234 0 14.6831 0.227087 14.6709 0.514791L14.1148 13.7004C13.7621 22.063 8.20516 29.3433 0.147217 32C17.8203 32 32.1472 17.8881 32.1472 0.480392V0Z" />
    </svg>
  ),
};

export default Tails;
